import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function SalesPage() {
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-246">
      <Hero data-id="element-247" />
      <ProblemSection data-id="element-248" />
      <MechanismSection data-id="element-249" />
      <WhatYouGetSection data-id="element-250" />
      <HowItWorksSection data-id="element-251" />
      <TestimonialsSection data-id="element-252" />
      <FAQSection data-id="element-253" />
      <OfferSection data-id="element-254" />
      <Footer data-id="element-255" />
      <StickyCTA data-id="element-256" />
    </div>;
}